import { gql } from '@apollo/client';

export const ALL_HOME_LANGUAGES = gql`
  query getHomeLanguages {
    homeLanguages: getHomeLanguages {
      id
      name
    }
  }
`;
